<template>
  <div id="OperEnergy-view">
    <dv-full-screen-container>
      <top-header :PageTitle="PageTitle" />
      <div class="main-content">
        <div class="block-top-bottom-content">
          <div class="block-top-button">
            <el-select v-model="selectedArea" placeholder="区域" @change="refreshDataOnChange()">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="selectedBU" placeholder="BU" @change="refreshDataOnChange()">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="selectedPlant" placeholder="工厂" style="width:300px;" @change="refreshData()">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input v-model="FilterNumber" style="width:300px;" placeholder="产品"></el-input>
            <el-button type="success" plain @click="refreshDataOnChange()">查询</el-button>
            <el-select v-model="selectedPlant" placeholder="产品工艺" style="width:300px;" @change="refreshData()">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button type="success" plain @click="saveRouteLayout()">保存</el-button>
          </div>
          <div class="main-content">
            <cydemo ref="routeComponent" />
          </div>
        </div>
      </div>

    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from '../TopMenu/topHeader';
import cydemo from './cydemo';
export default {
  name: 'OperEnergy',
  components: {
    topHeader,
    cydemo
  },
  data() {
    return {
      PageTitle: '设备生产过程能耗'
    }
  },
  methods: {
    saveRouteLayout() {
      this.$refs.routeComponent.exportCyJson()
    }
  }
};
</script>
<style lang="less" scoped>
#OperEnergy-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;
  #dv-full-screen-container {
    background-image: url("./img/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 45%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content-1 {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-button {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
}
</style>

